import moment from 'moment';
import React from 'react';
import ImageResize from '../common/ImageResize';

function SensorInfo(props) {

    var sortOrder = ['temperature', 'humidity', 'person', 'motion', 'co', 'co2', 'voc'];
    const formatSensorData = (sensor_rec, props) => {
        if (typeof sensor_rec === 'string') {
            return 'Last Update: ' + sensor_rec;
        }

        if (typeof sensor_rec === 'object' && sensor_rec) {
            if (sensor_rec.sensor_id === 'person') {
                return sensor_rec.value === 'People detected' ? 'Core Crew Member' : sensor_rec.value;
            }

            if (sensor_rec.sensor_id === 'motion') {
                return sensor_rec.value === '0'
                    ? 'Off'
                    : sensor_rec.value.length === 10
                        ? moment.tz(parseInt(sensor_rec.value) * 1000, props.timezone).format('MMM DD, YYYY HH:mm')
                        : sensor_rec.dev_timestamp;
            }

            if (
                sensor_rec.sensor_id === 'co' ||
                sensor_rec.sensor_id === 'voc' ||
                sensor_rec.sensor_id === 'co2' ||
                (!props.zoneInfo.location_device_type && (sensor_rec.sensor_id === 'humidity' || sensor_rec.sensor_id === 'temperature'))
            ) {
                const roundedValue = Math.round(sensor_rec.value, 2); // rounding to 2 decimal places
                return roundedValue === -100 ? '' : roundedValue +
                    (sensor_rec.sensor_id === 'temperature' ? ' °F' :
                        sensor_rec.sensor_id === 'humidity' ? ' %' :
                            sensor_rec.sensor_id === 'co2' ? ' ppm' :
                                sensor_rec.sensor_id === 'co' ? ' ppm' :
                                    sensor_rec.sensor_id === 'voc' ? ' ppb' : ''
                    );
            }

            if (sensor_rec.sensor_id === 'temperature') {
                const tempValue = Math.round(sensor_rec.value, 2);
                if (tempValue === -100) return '';
                return tempValue + ' °F';
            }

            if (sensor_rec.sensor_id === 'humidity') {
                const humidityValue = Math.round(sensor_rec.value, 2);
                if (humidityValue === -100) return '';
                return humidityValue + ' %';
            }

            if (sensor_rec.sensor_id === 'co2') {
                const co2Value = Math.round(sensor_rec.value, 2);
                return co2Value + ' ppm';
            }

            if (sensor_rec.sensor_id === 'co') {
                const coValue = Math.round(sensor_rec.value, 2);
                return coValue + ' ppm';
            }

            if (sensor_rec.sensor_id === 'voc') {
                const vocValue = Math.round(sensor_rec.value, 2);
                return vocValue + ' ppb';
            }
        }

        return ''; // Return an empty string if no conditions match
    };

    const abc = (
        <table className="table table-bordered font-size-12">
            <tbody>
                <tr>
                    <td className="p-0"></td>
                    {
                        props.data.images.map((img, x) => (
                            <td className="p-0" key={x}>
                                <ImageResize resize_perc="0.2" src={img} className="img-fluid"></ImageResize>
                            </td>
                        ))
                    }
                </tr>
                <tr>
                    <td></td>
                    {
                        props.data.persons.map((person, x) => (
                            <td key={x} className="px-1"><b>{person.dev_timestamp}</b>-{x === 0 ? 'First Appearance ' : x === 1 ? 'Max. Appearance ' : 'Last Appearance '}{person.person_count} person{person.person_count > 1 ? 's' : ''} </td>
                        ))
                    }
                </tr>
                {
                    props.data.sensorInfo && Object.keys(props.data.sensorInfo).length > 0 && Object.keys(props.data.sensorInfo).sort().map((device_id, i) => (

                        Object.keys(props.data.sensorInfo[device_id]).sort(function (x, y) {
                            var a = sortOrder.indexOf(x);
                            var b = sortOrder.indexOf(y);
                            return a < b ? -1 : a > b ? 1 : 0;
                        }).map((sensor_id, j) => (
                            <tr key={'sensor' + j} className={device_id === sensor_id ? 'bg-light' : ''}>
                                <td className='text-capitalize p-2'>{device_id === sensor_id ? <>{sensor_id.indexOf('Sensor') !== -1 ? [<b>{sensor_id.split(':')[0]}</b>, <br />, <small>{sensor_id.split(':')[1]}</small>] : <b>{sensor_id}</b>}</> : sensor_id}</td>
                                {
                                    props.data.sensorInfo[device_id] && props.data.sensorInfo[device_id][sensor_id] && props.data.sensorInfo[device_id][sensor_id].length > 0 && props.data.sensorInfo[device_id][sensor_id].sort().map((sensor_rec, k) => (
                                        <React.Fragment key={'device' + k}>
                                            <td className='p-2'>
                                                {formatSensorData(sensor_rec, props)}
                                            </td>
                                        </React.Fragment>
                                    ))
                                }
                            </tr>
                        ))
                    ))
                }
            </tbody>
        </table>
    );

    return abc;
}

export default SensorInfo;